import type { ReactNode } from "react";
import type { BuildCrumbs } from "./breadcrumbs.js";
import type { WorkspaceId } from "./workspaces.js";

/**
 * Everything a route handle may carry. Routes author handles through
 * `defineHandle` so the shape is checked at the definition site — React
 * Router's `handle` is untyped, and the zod guards on the consumer side can
 * only silently ignore a malformed handle, not flag it.
 */
export interface AppRouteHandle {
  /** The workspace the route belongs to, shown in the left nav. */
  workspaceId?: WorkspaceId;
  /** The left-nav menu for the route's section. */
  navigationMenu?: ReactNode;
  /**
   * The `/` route resolves its workspace indicator, menu, and crumbs from the
   * feature-flag-driven default workspace at render time.
   */
  defaultWorkspace?: boolean;
  /** The breadcrumb segments the route contributes to the top-bar trail. */
  crumbs?: BuildCrumbs;
}

export function defineHandle(handle: AppRouteHandle): AppRouteHandle {
  return handle;
}
